import { FiGithub, FiLinkedin, FiTwitter, FiArrowUp } from "react-icons/fi";

const links = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Skills", href: "#skills" },
  { label: "Work", href: "#portfolio" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

const socials = [
  { icon: FiLinkedin, href: "https://www.linkedin.com/in/shahed-talukder/", label: "LinkedIn" },
  { icon: FiGithub, href: "https://github.com/shahed-swe", label: "GitHub" },
  { icon: FiTwitter, href: "https://twitter.com/ShahedTalukder9", label: "Twitter" },
];

const Footer = () => {
  return (
    <footer className="relative z-10 border-t border-hairline px-6 pb-28 pt-16">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col items-center gap-7 text-center">
          <a
            href="#hero"
            className="font-display text-3xl font-bold text-gradient"
          >
            Shahed Talukder
          </a>
          <p className="max-w-md text-sm leading-relaxed text-muted">
            Creative fullstack developer crafting immersive, high-performance
            web experiences with motion and depth.
          </p>

          <ul className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-muted transition-colors hover:text-content"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex gap-3">
            {socials.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="flex h-11 w-11 items-center justify-center rounded-full border border-hairline bg-fill text-muted transition-all duration-300 hover:-translate-y-1 hover:text-content hover:shadow-glow"
              >
                <Icon />
              </a>
            ))}
          </div>

          <div className="h-px w-full max-w-sm bg-gradient-to-r from-transparent via-hairline to-transparent" />

          <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between sm:gap-6">
            <p className="text-xs text-faint">
              © {new Date().getFullYear()} Shahed Talukder. Built with React,
              Three.js &amp; Framer Motion.
            </p>
            <a
              href="#hero"
              className="inline-flex items-center gap-2 rounded-full border border-hairline bg-fill px-4 py-2 text-xs font-medium text-muted transition-all hover:-translate-y-0.5 hover:text-content"
            >
              Back to top <FiArrowUp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
